import AuthenticationService from '../AuthenticationService';

export function authHeader(){
    // return authorization header with jwt token
    // return {
    //     'Content-Type': 'application/json'
    // };
    
    const currentUser = AuthenticationService.currentUser;
    if(currentUser && currentUser.Token) {
        return {
            Authorization: `Bearer ${currentUser.Token}`,
            'Content-Type': 'application/json',
        };
    }
}